export const BOND_PLAY_BLUE_THEME = {
  "--bplay-accent": "#64B5F6",
  "--bplay-accent-bg": "rgba(100, 181, 246, 0.16)",
  "--bplay-accent-border": "rgba(100, 181, 246, 0.42)",
  "--bplay-accent-glow": "rgba(30, 136, 229, 0.45)",
};

export const BOND_PLAY_GAME_TYPES = [
  {
    id: "bond-wheel",
    short: "Wheel",
    accent: "#64B5F6",
    accentBg: "rgba(100, 181, 246, 0.16)",
    accentBorder: "rgba(100, 181, 246, 0.42)",
    accentGlow: "rgba(30, 136, 229, 0.45)",
    status: "live",
    route: "/app/bond-play",
    queryGame: "bond-wheel",
  },
  {
    id: "bond-spin",
    short: "Spin",
    accent: "#64B5F6",
    accentBg: "rgba(100, 181, 246, 0.16)",
    accentBorder: "rgba(100, 181, 246, 0.42)",
    accentGlow: "rgba(30, 136, 229, 0.45)",
    status: "live",
    route: "/app/bond-play",
    queryGame: "bond-spin",
  },
  {
    id: "bond-draw",
    short: "Draw",
    accent: "#64B5F6",
    accentBg: "rgba(100, 181, 246, 0.14)",
    accentBorder: "rgba(100, 181, 246, 0.4)",
    accentGlow: "rgba(30, 136, 229, 0.45)",
    status: "live",
    route: "/app/bond-play",
    queryGame: "bond-draw",
  },
  {
    id: "bond-coin",
    short: "Coin",
    accent: "#64B5F6",
    accentBg: "rgba(100, 181, 246, 0.16)",
    accentBorder: "rgba(100, 181, 246, 0.42)",
    accentGlow: "rgba(30, 136, 229, 0.45)",
    status: "live",
    route: "/app/bond-coin",
  },
  {
    id: "bond-dice",
    short: "Dice",
    accent: "#64B5F6",
    accentBg: "rgba(100, 181, 246, 0.16)",
    accentBorder: "rgba(100, 181, 246, 0.42)",
    accentGlow: "rgba(30, 136, 229, 0.45)",
    status: "live",
    route: "/app/bond-dice",
  },
  {
    id: "bond-numbers",
    short: "Numbers",
    accent: "#64B5F6",
    accentBg: "rgba(100, 181, 246, 0.16)",
    accentBorder: "rgba(100, 181, 246, 0.42)",
    accentGlow: "rgba(30, 136, 229, 0.45)",
    status: "live",
    route: "/app/bond-numbers",
  },
];

export function getBondPlayGameHref(type) {
  if (!type?.route) return "/app/bond-play";
  if (type.queryGame) {
    return `${type.route}?game=${type.queryGame}`;
  }
  return type.route;
}

export function findBondPlayGameType(id) {
  return BOND_PLAY_GAME_TYPES.find((g) => g.id === id) || BOND_PLAY_GAME_TYPES[0];
}
